import React, {
  useState,
  useMemo,
  useContext,
  createContext,
  useCallback,
} from "react";
import { toast } from "react-toastify";
import fetchHistoryPage from "../service/history";

const MedicalHistoryContext = createContext();

const MedicalHistoryProvider = ({ children }) => {
  const [data, setData] = useState({
    patientName: "",
    prescriptions: null,
    loading: false,
    success: true,
  });
  const [pagination, setPagination] = useState({
    hasNext: false,
    nextOffset: 0,
  });

  const handlerResponse = useCallback(({ prescriptions, pagination: page }, isNextPage) => {
    setPagination(page);

    const patientName = prescriptions?.[0]?.patientName;

    if (isNextPage) {
      return setData((prevState) => ({
        ...prevState,
        loading: false,
        prescriptions: [...(prevState.prescriptions || []), ...(prescriptions || [])],
      }));
    }

    setData({
      patientName,
      prescriptions,
      loading: false,
      success: true,
    });
  }, []);

  const getPrescriptions = useCallback(
    (offset = 0) => {
      const isNextPage = offset > 0;

      setData((prevState) => ({ ...prevState, loading: true }));

      return fetchHistoryPage({ offset })
        .then((page) => handlerResponse(page, isNextPage))
        .catch((error) => {
          console.error(error);

          setData((prevState) => ({ ...prevState, success: false }));

          toast.error(
            "Não foi possível carregar as prescrições do paciente. Tente novamente."
          );
        });
    },
    [handlerResponse]
  );

  const value = useMemo(
    () => ({
      getPrescriptions,
      data,
      pagination,
    }),
    [data, getPrescriptions, pagination]
  );

  return (
    <MedicalHistoryContext.Provider value={value}>
      {children}
    </MedicalHistoryContext.Provider>
  );
};

const useMedicalHistory = () => {
  const context = useContext(MedicalHistoryContext);
  if (context === undefined) {
    throw new Error(
      "useMedicalHistory can only be used inside MedicalHistoryProvider"
    );
  }
  return context;
};

export { MedicalHistoryProvider, useMedicalHistory };
